import React from 'react'
import { Spinner } from 'src/components/common/Spinner'

interface LoadMoreButtonProps {
  onClick: () => void
  loading: boolean
  testId: string
  ariaLabel: string
  isMobile?: boolean
}

const ButtonContent = ({ loading }: { loading: boolean }) => {
  return (
    <>
      {loading ? (
        <>
          Carregando
          <Spinner color="#15181B" />
        </>
      ) : (
        'Carregar mais'
      )}
    </>
  )
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  onClick,
  loading,
  testId,
  ariaLabel,
  isMobile = false,
}) => {
  return (
    <button
      data-testid={testId}
      aria-label={ariaLabel}
      className={`desktop-body-semibold-text2 flex-row items-center text-center
        rounded-[360px] justify-center mt-3 py-4 px-4 w-full
        border border-checkoutInputBorder gap-2 ${
          isMobile
            ? 'restructure-tablet:hidden flex'
            : 'restructure-tablet:flex hidden'
        }`}
      onClick={onClick}
    >
      <ButtonContent loading={loading} />
    </button>
  )
}

export default LoadMoreButton
